import React from "react";
import PlatformAnalyticsExperience from "./PlatformAnalyticsExperience";

/*
 * Audio Analytics — served by the shared Platform Analytics experience. The
 * route, page title, report-link contract and topline data contract are
 * unchanged; the profile lives in
 * src/platformAnalytics/platformAnalyticsProfiles.js.
 *
 * The inventory-transparency module this page had before the migration is
 * preserved through the profile's distributionTransparencyChannel.
 *
 * No connector reports Audio creative-level delivery, so the profile declares
 * no creativePerformancePlatformKey and the Creative Performance section
 * renders its governed unsupported state rather than an empty grid.
 */
export default function AudioAnalytics() {
  return <PlatformAnalyticsExperience platformKey="audio" />;
}
